import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import CandidateDetails from 'containers/pendingPage/subComponents/CandidateDetails';
import ProgressBarChecks from 'components/global/progressBar/ProgressBarChecks';
import { PageWrapper } from 'components/local/styles/StyledComponents';

const PendingPage = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper>
      <CandidateWrapper>
        {/* Hardcoded for taker data only, but should eventually include disclaimer, message, etc */}
        <ProgressBarChecks
          currentSlot={0}
          slotLabels={[t('takerDetailsPage.candidateDetails')]}
        />
        <CandidateDetails />
      </CandidateWrapper>
    </PageWrapper>
  );
};

const CandidateWrapper = styled.div`
  padding: 0 16px;
  max-width: 960px;
  margin: auto;
`;

export default PendingPage;
